import { render, staticRenderFns } from "./community-hub.vue?vue&type=template&id=0fca7800&scoped=true&"
import script from "./community-hub.ts?vue&type=script&lang=ts&"
export * from "./community-hub.ts?vue&type=script&lang=ts&"
import style0 from "./community-hub.scss?vue&type=style&index=0&id=0fca7800&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fca7800",
  null
  
)

export default component.exports